import { lazy } from 'react';

// Lazy load components for better performance
export const LazyPricingSectionAPI = lazy(() => import('../components/PricingSectionAPI'));
export const LazyDemoModal = lazy(() => import('../components/DemoModal'));
export const LazyWhatsAppIcon = lazy(() => import('../components/WhatsAppIcon'));

// Pages
export const LazyHome = lazy(() => import('../pages/Home'));
export const LazyFeatures = lazy(() => import('../pages/Features'));
export const LazyPricing = lazy(() => import('../pages/Pricing'));
export const LazyAboutUs = lazy(() => import('../pages/AboutUs'));
export const LazyContactUs = lazy(() => import('../pages/ContactUs'));
export const LazyPrivacyPolicy = lazy(() => import('../pages/PrivacyPolicy'));
export const LazyUserAgreement = lazy(() => import('../pages/UserAgreement'));
